<div class="filter filter-padded-left" [class.disabled]="!equipment.show">
  <span class="filter-body">
    <div class="filter-title filter-label">
      Regular {{ jewellery ? 'Jewellery' : gear ? 'Gear' : 'Jewels' }}

      <div class="filter-tip">
        <p>
          Show regular <span class="rare-item-color">Rare</span>, <span class="magic-item-color">Magic</span> and/or <span class="normal-item-color">Normal</span> equipment of your chosen type(s).
          <br /><br />Disable these if you're only interested in special versions of these items, specified below.
        </p>
      </div>
    </div>

    <span class="sep"></span>

    <div class="filter-title filter-label table-checkbox-group"
      [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (equipment.highlightConfig.equipmentType === 'gear' ? 'gear-my-regular-rare' : equipment.highlightConfig.equipmentType === 'jewel' ? 'jewels-my-rare' : 'jewellery-my-regular-rare') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
      (click)="onHighlightClick($event)"
      (mouseenter)="onHighlightMouseEnter($event)"
      (mouseleave)="onHighlightMouseLeave($event)">
      <span class="input-group-btn">
        <button class="btn toggle-btn"
          [class.off]="equipment.highlightConfig.regularRare === false"
          [disabled]="!equipment.show"
          (click)="toggleRegularRare()"></button>
      </span>
      <div class="table-checkbox-label">
        <span class="filter-title-text">Rare</span>

        @if (!isMobile()) {
          <app-equipment-tier-picker
            [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearRegularRare : equipment.highlightConfig.equipmentType === 'jewel' ? EquipmentType.MyJewelsRare : EquipmentType.MyJewelleryRegularRare"
            [active]="equipment.highlightConfig.regularRare"
            exampleName="{{ getExampleGearName() }}"
            [rarity]="Rarity.Rare"></app-equipment-tier-picker>
        }
      </div>
    </div>

    @if (equipment.rarity === Rarity.Magic || equipment.rarity === Rarity.Normal) {

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (equipment.highlightConfig.equipmentType === 'gear' ? 'gear-my-regular-magic' : equipment.highlightConfig.equipmentType === 'jewel' ? 'jewels-my-magic' : 'jewellery-my-regular-magic') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="equipment.highlightConfig.regularMagic === false"
            [disabled]="!equipment.show"
            (click)="toggleRegularMagic()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Magic</span>

          @if (!isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearRegularMagic : equipment.highlightConfig.equipmentType === 'jewel' ? EquipmentType.MyJewelsMagic : EquipmentType.MyJewelleryRegularMagic"
              [active]="equipment.highlightConfig.regularMagic"
              exampleName="{{ getExampleGearName() }}"
              [rarity]="Rarity.Magic"></app-equipment-tier-picker>
          }
        </div>
      </div>

      @if (gearOrJewellery && gearOrJewellery.rarity === Rarity.Normal) {
        <span class="sep"></span>

        <div class="filter-title filter-label table-checkbox-group"
          [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (equipment.highlightConfig.equipmentType === 'gear' ? 'gear-my-regular-normal' : 'jewellery-my-regular-normal') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
          (click)="onHighlightClick($event)"
          (mouseenter)="onHighlightMouseEnter($event)"
          (mouseleave)="onHighlightMouseLeave($event)">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="gearOrJewellery.highlightConfig.regularNormal === false"
              [disabled]="!equipment.show"
              (click)="toggleRegularNormal()"></button>
          </span>
          <div class="table-checkbox-label">
            <span class="filter-title-text">Normal</span>

            @if (!isMobile()) {
              <app-equipment-tier-picker
                [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearRegularNormal : EquipmentType.MyJewelleryRegularNormal"
                [active]="gearOrJewellery.highlightConfig.regularNormal"
                exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
            }
          </div>
        </div>
      }
    }

    <span class="spacer" style="display: table-cell; width: 100%;"></span>
  </span>
</div>

@if (poe2 && gearOrJewellery) {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show || isTierDisabled(5)">
    <span class="filter-body">
      <div class="filter-title filter-label">
        Unidentified

        <div class="filter-tip">
          <p>
            Additionally highlight Tiered Unidentified <span class="rare-item-color">Rare</span> and <span class="magic-item-color">Magic</span> equipment with the specified minimum Unidentified Tiers, so they stand out more. You can configure which Unidentified Tier receives which highlight tier on the <a href="/tier-list/equipment">Equipment Tier List</a> tab.
            <br /><br />Disabling these options will <i>not</i> hide these items, but cause them to just be shown, not highlighted; unless you also disable the 'Regular' options above.
          </p>
        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (equipment.highlightConfig.equipmentType === 'gear' ? 'gear-my-rare-t5' : 'jewellery-my-rare-t5') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event, true)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="gearOrJewellery.highlightConfig.rare === false"
            [disabled]="!equipment.show || isTierDisabled(5)"
            (click)="toggleHighlightRare()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Rare</span>

          @if (gearOrJewellery.highlightConfig.rare && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearRareT5 : EquipmentType.MyJewelleryRareT5"
              [active]="gearOrJewellery.highlightConfig.rare"
              exampleName="{{ getExampleGearName() }} (Tier 5)"
              [rarity]="Rarity.Rare"></app-equipment-tier-picker>

            @if ((!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 4) && gearOrJewellery.highlightConfig.rareMinTier <= 4) {
              <app-equipment-tier-picker
                [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearRareT4 : EquipmentType.MyJewelleryRareT4"
                [active]="gearOrJewellery.highlightConfig.rare"
                exampleName="{{ getExampleGearName() }} (Tier 4)"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            }
            @if ((!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 3) && gearOrJewellery.highlightConfig.rareMinTier <= 3) {
              <app-equipment-tier-picker
                [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearRareT3 : EquipmentType.MyJewelleryRareT3"
                [active]="gearOrJewellery.highlightConfig.rare"
                exampleName="{{ getExampleGearName() }} (Tier 3)"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            }
            @if ((!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 2) && gearOrJewellery.highlightConfig.rareMinTier <= 2) {
              <app-equipment-tier-picker
                [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearRareT2 : EquipmentType.MyJewelleryRareT2"
                [active]="gearOrJewellery.highlightConfig.rare"
                exampleName="{{ getExampleGearName() }} (Tier 2)"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            }
          }

        </div>
      </div>
      <span class="sep"></span>

      <app-select style="width: 65px" [disabled]="!gearOrJewellery.highlightConfig.rare" [(ngModel)]="gearOrJewellery.highlightConfig.rareMinTier" (selectedValueChange)="updateFilter()">
        @if (!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 2) { <app-option [value]="2" [text]="'≥ T2'"></app-option> }
        @if (!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 3) { <app-option [value]="3" [text]="'≥ T3'"></app-option> }
        @if (!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 4) { <app-option [value]="4" [text]="'≥ T4'"></app-option> }
        <app-option [value]="5" [text]="'T5'"></app-option>
      </app-select>

      @if (equipment.rarity === Rarity.Magic || equipment.rarity === Rarity.Normal) {
        <span class="sep"></span>

        <div class="filter-title filter-label table-checkbox-group"
          [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (equipment.highlightConfig.equipmentType === 'gear' ? 'gear-my-magic-t5' : 'jewellery-my-magic-t5') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
          (click)="onHighlightClick($event, true)"
          (mouseenter)="onHighlightMouseEnter($event)"
          (mouseleave)="onHighlightMouseLeave($event)">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="gearOrJewellery.highlightConfig.magic === false"
              [disabled]="!equipment.show || isTierDisabled(5)"
              (click)="toggleHighlightMagic()"></button>
          </span>
          <div class="table-checkbox-label">
            <span class="filter-title-text">Magic</span>

            @if (gearOrJewellery.highlightConfig.rare && !isMobile()) {
              <app-equipment-tier-picker
                [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearMagicT5 : EquipmentType.MyJewelleryMagicT5"
                [active]="gearOrJewellery.highlightConfig.magic"
                exampleName="{{ getExampleGearName() }} (Tier 5)"
                [rarity]="Rarity.Magic"></app-equipment-tier-picker>

              @if ((!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 4) && gearOrJewellery.highlightConfig.magicMinTier <= 4) {
                <app-equipment-tier-picker
                  [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearMagicT4 : EquipmentType.MyJewelleryMagicT4"
                  [active]="gearOrJewellery.highlightConfig.magic"
                  exampleName="{{ getExampleGearName() }} (Tier 4)"
                  [rarity]="Rarity.Magic"></app-equipment-tier-picker>
              }
              @if ((!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 3) && gearOrJewellery.highlightConfig.magicMinTier <= 3) {
                <app-equipment-tier-picker
                  [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearMagicT3 : EquipmentType.MyJewelleryMagicT3"
                  [active]="gearOrJewellery.highlightConfig.magic"
                  exampleName="{{ getExampleGearName() }} (Tier 3)"
                  [rarity]="Rarity.Magic"></app-equipment-tier-picker>
              }
              @if ((!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 2) && gearOrJewellery.highlightConfig.magicMinTier <= 2) {
                <app-equipment-tier-picker
                  [equipmentType]="equipment.highlightConfig.equipmentType === 'gear' ? EquipmentType.MyGearMagicT2 : EquipmentType.MyJewelleryMagicT2"
                  [active]="gearOrJewellery.highlightConfig.magic"
                  exampleName="{{ getExampleGearName() }} (Tier 2)"
                  [rarity]="Rarity.Magic"></app-equipment-tier-picker>
              }
            }

          </div>
        </div>

        <span class="sep"></span>

        <app-select style="width: 65px" [disabled]="!gearOrJewellery.highlightConfig.magic" [(ngModel)]="gearOrJewellery.highlightConfig.magicMinTier" (selectedValueChange)="updateFilter()">
          @if (!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 2) { <app-option [value]="2" [text]="'≥ T2'"></app-option> }
          @if (!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 3) { <app-option [value]="3" [text]="'≥ T3'"></app-option> }
          @if (!gearOrJewellery.unidentifiedTier || gearOrJewellery.unidentifiedTier <= 4) { <app-option [value]="4" [text]="'≥ T4'"></app-option> }
          <app-option [value]="5" [text]="'T5'"></app-option>
        </app-select>
      }

      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (poe2 && gear && gear.baseTypeTier !== BaseTypeTier.Basic && gear.baseTypeMode !== GearBaseTypeMode.Specific) {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show || isTierDisabled(5)">
    <span class="filter-body">
      <div class="filter-title filter-label">
        {{ getLowerTierName() }} {{ isMobile() ? '' : 'Unidentified' }}

        <div class="filter-tip">
          <p>
            Additionally show and highlight Tiered Unidentified <span class="rare-item-color">Rare</span> and <span class="magic-item-color">Magic</span> equipment one Gear Tier lower than your selected Gear Tier, with the specified minimum Unidentified Tiers. You can configure which Unidentified Tier receives which highlight on the <a href="/tier-list/equipment">Equipment Tier List</a> tab.
            <br /><br />If you disable these options, these lower tier items will not be shown unless specified by other rules, for example in the 'Other Equipment' section.
          </p>
        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-lower-tier-rare-t5/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event, true)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="gear.highlightConfig.lowTierRare === false"
            [disabled]="!equipment.show || isTierDisabled(5)"
            (click)="toggleHighlightLowTierRare()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Rare</span>

          @if (gear.highlightConfig.lowTierRare && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.MyGearLowerGearTierRareT5"
              [active]="gear.highlightConfig.lowTierRare"
              exampleName="{{ getExampleGearName() }} (Tier 5)"
              [rarity]="Rarity.Rare"></app-equipment-tier-picker>

            @if ((!gear.unidentifiedTier || gear.unidentifiedTier <= 4) && gear.highlightConfig.lowTierRareMinTier <= 4) {
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.MyGearLowerGearTierRareT4"
                [active]="gear.highlightConfig.lowTierRare"
                exampleName="{{ getExampleGearName() }} (Tier 4)"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            }
            @if ((!gear.unidentifiedTier || gear.unidentifiedTier <= 3) && gear.highlightConfig.lowTierRareMinTier <= 3) {
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.MyGearLowerGearTierRareT3"
                [active]="gear.highlightConfig.lowTierRare"
                exampleName="{{ getExampleGearName() }} (Tier 3)"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            }
          }

        </div>
      </div>

      <span class="sep"></span>

      <app-select style="width: 65px" [disabled]="!gear.highlightConfig.lowTierRare" [(ngModel)]="gear.highlightConfig.lowTierRareMinTier" (selectedValueChange)="updateFilter()">
        @if (!gear.unidentifiedTier || gear.unidentifiedTier <= 3) { <app-option [value]="3" [text]="'≥ T3'"></app-option> }
        @if (!gear.unidentifiedTier || gear.unidentifiedTier <= 4) { <app-option [value]="4" [text]="'≥ T4'"></app-option> }
        <app-option [value]="5" [text]="'T5'"></app-option>
      </app-select>

      @if (equipment.rarity === Rarity.Magic || equipment.rarity === Rarity.Normal) {
        <span class="sep"></span>

        <div class="filter-title filter-label table-checkbox-group"
          [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-lower-tier-magic-t5/' + equipmentType + '/' + (equipmentIndex + 1) : null"
          (click)="onHighlightClick($event, true)"
          (mouseenter)="onHighlightMouseEnter($event)"
          (mouseleave)="onHighlightMouseLeave($event)">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="gear.highlightConfig.lowTierMagic === false"
              [disabled]="!equipment.show || isTierDisabled(5)"
              (click)="toggleHighlightLowTierMagic()"></button>
          </span>
          <div class="table-checkbox-label">
            <span class="filter-title-text">Magic</span>

            @if (gear.highlightConfig.lowTierMagic && !isMobile()) {
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.MyGearLowerGearTierMagicT5"
                [active]="gear.highlightConfig.lowTierMagic"
                exampleName="{{ getExampleGearName() }} (Tier 5)"
                [rarity]="Rarity.Magic"></app-equipment-tier-picker>

              @if ((!gear.unidentifiedTier || gear.unidentifiedTier <= 4) && gear.highlightConfig.lowTierMagicMinTier <= 4) {
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.MyGearLowerGearTierMagicT4"
                  [active]="gear.highlightConfig.lowTierMagic"
                  exampleName="{{ getExampleGearName() }} (Tier 4)"
                  [rarity]="Rarity.Magic"></app-equipment-tier-picker>
              }
              @if ((!gear.unidentifiedTier || gear.unidentifiedTier <= 3) && gear.highlightConfig.lowTierMagicMinTier <= 3) {
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.MyGearLowerGearTierMagicT3"
                  [active]="gear.highlightConfig.lowTierMagic"
                  exampleName="{{ getExampleGearName() }} (Tier 3)"
                  [rarity]="Rarity.Magic"></app-equipment-tier-picker>
              }
            }

          </div>
        </div>

        <span class="sep"></span>

        <app-select style="width: 65px" [disabled]="!gear.highlightConfig.lowTierMagic" [(ngModel)]="gear.highlightConfig.lowTierMagicMinTier" (selectedValueChange)="updateFilter()">
          @if (!gear.unidentifiedTier || gear.unidentifiedTier <= 3) { <app-option [value]="3" [text]="'≥ T3'"></app-option> }
          @if (!gear.unidentifiedTier || gear.unidentifiedTier <= 4) { <app-option [value]="4" [text]="'≥ T4'"></app-option> }
          <app-option [value]="5" [text]="'T5'"></app-option>
        </app-select>
      }

      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (poe2 && gear) {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show || isTierDisabled(5)">
    <span class="filter-body">
      <div class="filter-title filter-label">
        Exceptional {{ isMobile() ? '' : 'Crafting Bases' }}

        <div class="filter-tip">
          <p>
            Additionally highlight Exceptional <span class="normal-item-color">Normal</span> gear of your chosen type(s) (ignoring your chosen minimum Rarity). Exceptional gear is <span class="normal-item-color">Normal</span> gear with more than 20 Quality or an extra Socket.
            <br /><br />Exceptional Socketed gear is always considered Excellent. Exceptional Quality gear is either Excellent or Good, depending on the quality. You can specify the minimum required Quality for both.
            <br /><br />If you disable these options, these items will not be shown unless specified by other rules, for example in the 'Other Equipment' section.
          </p>
        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-excellent-exceptional/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="gear.highlightConfig.excellentExceptional === false"
            [disabled]="!equipment.show"
            (click)="toggleExcellentExceptional()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Excellent</span>

          @if (gear.highlightConfig.excellentExceptional && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.MyGearExcellentExceptional"
              [active]="gear.highlightConfig.excellentExceptional"
              exampleName="Exceptional {{ getExampleGearName() }}"></app-equipment-tier-picker>
          }

        </div>
      </div>

      <span class="sep"></span>

      <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
        [disabled]="!equipment.show || gear.highlightConfig.excellentExceptional === false"
        [(ngModel)]="gear.highlightConfig.excellentExceptionalMinQuality" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

        <span class="sep"></span>

        <div class="filter-title filter-label table-checkbox-group"
          [class.disabled]="!gear.highlightConfig.goodExceptional"
          [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-good-exceptional/' + equipmentType + '/' + (equipmentIndex + 1) : null"
          (click)="onHighlightClick($event)"
          (mouseenter)="onHighlightMouseEnter($event)"
          (mouseleave)="onHighlightMouseLeave($event)">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="gear.highlightConfig.goodExceptional === false"
              [disabled]="!equipment.show"
              (click)="toggleGoodExceptional()"></button>
          </span>
          <div class="table-checkbox-label">
            <span class="filter-title-text">Good</span>

            @if (gear.highlightConfig.excellentExceptional && !isMobile()) {
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.MyGearGoodExceptional"
                [active]="gear.highlightConfig.goodExceptional"
                exampleName="Exceptional {{ getExampleGearName() }}"></app-equipment-tier-picker>
            }

          </div>
        </div>

        <span class="sep"></span>

        <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!equipment.show || gear.highlightConfig.excellentExceptional === false"
          [(ngModel)]="gear.highlightConfig.goodExceptionalMinQuality" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (poe1 && gear) {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show">
    <span class="filter-body">
      <div class="filter-title filter-label">
        Crafting {{ isMobile() ? '' : 'Bases' }}

        <div class="filter-tip">
          <p>
            Additionally show and highlight gear of your chosen type(s), ignoring your chosen minimum Rarity, with at least the specified Quality and Item Level. Items with high Item Levels can contain the highest level mods, and are thus good candidates to craft on.
            <br /><br />If you disable these options, these items will not be shown unless specified by other rules, for example in the 'Other Equipment' section.
          </p>
        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-excellent-crafting-base/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="gear.highlightConfig.excellentCraftingBase === false"
            [disabled]="!equipment.show"
            (click)="toggleExcellentCraftingBase()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Excellent</span>

          @if (gear.highlightConfig.excellentCraftingBase && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.MyGearExcellentCraftingBase"
              [active]="gear.highlightConfig.excellentCraftingBase"
              exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
          }

        </div>
      </div>

      <span class="sep"></span>

      <input type="number" placeholder="q" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
        [disabled]="!equipment.show || gear.highlightConfig.excellentCraftingBase === false"
        [(ngModel)]="gear.highlightConfig.excellentCraftingBaseMinQuality" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

      <span class="sep"></span>

      <input type="number" placeholder="ilvl" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
        [disabled]="!equipment.show || gear.highlightConfig.excellentCraftingBase === false"
        [(ngModel)]="gear.highlightConfig.excellentCraftingBaseMinItemLevel" (change)="updateFilter()" style="min-width: 50px; width: 50px;">

        <span class="sep"></span>

        <div class="filter-title filter-label table-checkbox-group"
          [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-good-crafting-base/' + equipmentType + '/' + (equipmentIndex + 1) : null"
          (click)="onHighlightClick($event)"
          (mouseenter)="onHighlightMouseEnter($event)"
          (mouseleave)="onHighlightMouseLeave($event)">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="gear.highlightConfig.goodCraftingBase === false"
              [disabled]="!equipment.show"
              (click)="toggleGoodCraftingBase()"></button>
          </span>
          <div class="table-checkbox-label">
            <span class="filter-title-text">Good</span>

            @if (gear.highlightConfig.excellentCraftingBase && !isMobile()) {
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.MyGearGoodCraftingBase"
                [active]="gear.highlightConfig.goodCraftingBase"
                exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
            }

          </div>
        </div>

        <span class="sep"></span>

        <input type="number" placeholder="q" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!equipment.show || gear.highlightConfig.excellentCraftingBase === false"
          [(ngModel)]="gear.highlightConfig.goodCraftingBaseMinQuality" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

        <span class="sep"></span>

        <input type="number" placeholder="ilvl" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!equipment.show || gear.highlightConfig.excellentCraftingBase === false"
          [(ngModel)]="gear.highlightConfig.goodCraftingBaseMinItemLevel" (change)="updateFilter()" style="min-width: 50px; width: 50px;">

      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (poe1 && (gear || jewellery)) {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show">
    <span class="filter-body">
      <div class="filter-title filter-label">
        Memory {{ isMobile() ? '' : 'Strands' }}

        <div class="filter-tip">
          <p>
            Additionally show and highlight {{ gear ? 'gear' : 'jewellery' }} of your chosen type(s) with at least the specified Memory Strands. Items with more Memory Strands result in better outcomes when identifying or crafting on.
            <br /><br />If you disable these options, these items will not be shown unless specified by other rules, for example in the 'Other Equipment' section.
          </p>
        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (gear ? 'gear-my-excellent-memory-strands' : 'jewellery-my-excellent-memory-strands') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="(gear ? gear.highlightConfig.excellentMemoryStrands : jewellery!.highlightConfig.excellentMemoryStrands) === false"
            [disabled]="!equipment.show"
            (click)="toggleExcellentMemoryStrands()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Excellent</span>

          @if ((gear ? gear.highlightConfig.excellentMemoryStrands : jewellery!.highlightConfig.excellentMemoryStrands) && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="gear ? EquipmentType.MyGearExcellentMemoryStrands : EquipmentType.MyJewelleryExcellentMemoryStrands"
              [active]="gear ? gear.highlightConfig.excellentMemoryStrands : jewellery!.highlightConfig.excellentMemoryStrands"
              exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
          }

        </div>
      </div>

      <span class="sep"></span>

      <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
        [disabled]="!equipment.show || (gear ? gear.highlightConfig.excellentMemoryStrands : jewellery!.highlightConfig.excellentMemoryStrands) === false"
        [ngModel]="gear ? gear.highlightConfig.excellentMemoryStrandsMinStrands : jewellery!.highlightConfig.excellentMemoryStrandsMinStrands"
        (ngModelChange)="gear ? gear.highlightConfig.excellentMemoryStrandsMinStrands = $event : jewellery!.highlightConfig.excellentMemoryStrandsMinStrands = $event; updateFilter()"
        (change)="updateFilter()" style="min-width: 40px; width: 40px;">

        <span class="sep"></span>

        <div class="filter-title filter-label table-checkbox-group"
          [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (gear ? 'gear-my-good-memory-strands' : 'jewellery-my-good-memory-strands') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
          (click)="onHighlightClick($event)"
          (mouseenter)="onHighlightMouseEnter($event)"
          (mouseleave)="onHighlightMouseLeave($event)">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="(gear ? gear.highlightConfig.goodMemoryStrands : jewellery!.highlightConfig.goodMemoryStrands) === false"
              [disabled]="!equipment.show"
              (click)="toggleGoodMemoryStrands()"></button>
          </span>
          <div class="table-checkbox-label">
            <span class="filter-title-text">Good</span>

            @if ((gear ? gear.highlightConfig.excellentMemoryStrands : jewellery!.highlightConfig.excellentMemoryStrands) && !isMobile()) {
              <app-equipment-tier-picker
                [equipmentType]="gear ? EquipmentType.MyGearGoodMemoryStrands : EquipmentType.MyJewelleryGoodMemoryStrands"
                [active]="gear ? gear.highlightConfig.goodMemoryStrands : jewellery!.highlightConfig.goodMemoryStrands"
                exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
            }

          </div>
        </div>

        <span class="sep"></span>

        <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!equipment.show || (gear ? gear.highlightConfig.excellentMemoryStrands : jewellery!.highlightConfig.excellentMemoryStrands) === false"
          [ngModel]="gear ? gear.highlightConfig.goodMemoryStrandsMinStrands : jewellery!.highlightConfig.goodMemoryStrandsMinStrands"
          (ngModelChange)="gear ? gear.highlightConfig.goodMemoryStrandsMinStrands = $event : jewellery!.highlightConfig.goodMemoryStrandsMinStrands = $event; updateFilter()"
          (change)="updateFilter()" style="min-width: 40px; width: 40px;">

      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (poe1 && gear) {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show">
    <span class="filter-body">
      <div class="filter-title filter-label">
        Links

        <div class="filter-tip">
          <p>
            Additionally show and highlight gear of your chosen type(s) with 6 or 5 linked sockets.
            <br /><br />If you disable these options, these items will not be shown unless specified by other rules, for example the '6-Link' rule in the 'Crafting Bases' section.
          </p>
        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-six-link/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="gear.highlightConfig.sixLink === false"
            [disabled]="!equipment.show"
            (click)="toggleSixLink()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">6-Link</span>

          @if (gear.highlightConfig.sixLink && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.MyGear6Link"
              [active]="gear.highlightConfig.sixLink"
              exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
          }

        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-five-link/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="gear.highlightConfig.fiveLink === false"
            [disabled]="!equipment.show"
            (click)="toggleFiveLink()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">5-Link</span>

          @if (gear.highlightConfig.fiveLink && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.MyGear5Link"
              [active]="gear.highlightConfig.fiveLink"
              exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
          }

        </div>
      </div>

      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (poe1 && gear) {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show">
    <span class="filter-body">
      <div class="filter-title filter-label">
        Colours

        <div class="filter-tip">
          <p>
            Additionally show and highlight gear of your chosen type(s) with the specified socket colours (not necessarily linked).
            Enter a string of characters representing socket colours. For example, '<strong>RRGX</strong>' would select all gear with at least 4 sockets, of which two are <strong>R</strong>ed and one is <strong>G</strong>reen. The <strong>X</strong> can be any colour.
            <br /><br />If you disable this option, these items will not be shown unless specified by other rules, for example the colour rules in the 'Crafting Bases' section.
          </p>
        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'gear-my-coloured-sockets/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="gear.highlightConfig.colouredSockets === false"
            [disabled]="!equipment.show"
            (click)="toggleColouredSockets()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Coloured Sockets</span>

          @if (gear.highlightConfig.colouredSockets && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.MyGearColouredSockets"
              [active]="gear.highlightConfig.colouredSockets"
              exampleName="{{ getExampleGearName() }}"
              [sockets]="gear.highlightConfig.colouredSocketsColours"></app-equipment-tier-picker>
          }

        </div>
      </div>

      <span class="sep"></span>

      <input type="text" placeholder="RGBWX" minlength="1" maxlength="6" pattern="[RGBWXT]{1,6}" class="form-control"
        [disabled]="!equipment.show || gear.highlightConfig.colouredSockets === false"
        [(ngModel)]="gear.highlightConfig.colouredSocketsColours"
        (keydown)="socketGroupKeyDown($event)"
        (change)="updateFilter()"
        style="min-width: 90px; width: 90px;">

      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if ((poe2 && !jewel) || (poe1 && (jewel || jewellery))) {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show || isTierDisabled(5)">
    <span class="filter-body">
      <div class="filter-title filter-label">
        iLevel Crafting {{ isMobile() ? '' : 'Bases' }}

        <div class="filter-tip">
          <p>
            @if (poe2) {
              Additionally show and/or highlight <span class="normal-item-color">Normal</span> gear of your chosen type(s) (ignoring your chosen minimum Rarity) with at least the specified Item Level. Items with higher Item Levels can contain the highest level mods, and are thus good candidates to craft on. <br /><br />If you disable these options, these items will not be shown unless specified by other rules, for example in the 'Other Equipment' section.
            } @else {
              Additionally show and/or highlight jewellery of your chosen type(s) with at least the specified Item Level. Items with higher Item Levels can contain the highest level mods, and are thus good candidates to craft on. <br /><br />If you disable these options, these items will not be shown unless specified by other rules, for example in the 'Other Equipment' section.
            }
          </p>
        </div>
      </div>

      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [class.disabled]="equipment.highlightConfig.excellentILevel === false || (equipment.itemLevel ?? 0) >= (equipment.highlightConfig.excellentILevelMin ?? 85)"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (equipment.highlightConfig.equipmentType === 'jewel' ? 'jewels-my-excellent-ilevel' : equipment.highlightConfig.equipmentType === 'jewellery' ? 'jewellery-my-excellent-ilevel' : 'gear-my-excellent-ilevel') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="equipment.highlightConfig.excellentILevel === false || (equipment.itemLevel ?? 0) >= (equipment.highlightConfig.excellentILevelMin ?? 85)"
            [disabled]="!equipment.show || (equipment.itemLevel ?? 0) >= (equipment.highlightConfig.excellentILevelMin ?? 85)"
            (click)="toggleExcellentILevel()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Excellent</span>

          @if (equipment.highlightConfig.excellentILevel && !isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="equipment.highlightConfig.equipmentType === 'jewel' ? EquipmentType.MyJewelsExcellentILevel : equipment.highlightConfig.equipmentType === 'jewellery' ? EquipmentType.MyJewelleryExcellentILevel : EquipmentType.MyGearExcellentILevel"
              [active]="equipment.highlightConfig.excellentILevel"
              exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
          }

        </div>
      </div>

      <span class="sep"></span>

      <input type="number" placeholder="min" maxlength="3" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
        [disabled]="!equipment.show || equipment.highlightConfig.excellentILevel === false"
        [(ngModel)]="equipment.highlightConfig.excellentILevelMin" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

        <span class="sep"></span>

        <div class="filter-title filter-label table-checkbox-group"
          [class.disabled]="equipment.highlightConfig.goodILevel === false || (equipment.itemLevel ?? 0) > (equipment.highlightConfig.goodILevelMin ?? 84)"
          [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? (equipment.highlightConfig.equipmentType === 'jewel' ? 'jewels-my-good-ilevel' : equipment.highlightConfig.equipmentType === 'jewellery' ? 'jewellery-my-good-ilevel' : 'gear-my-good-ilevel') + '/' + equipmentType + '/' + (equipmentIndex + 1) : null"
          (click)="onHighlightClick($event)"
          (mouseenter)="onHighlightMouseEnter($event)"
          (mouseleave)="onHighlightMouseLeave($event)">
          <span class="input-group-btn">
            <button class="btn toggle-btn"
              [class.off]="equipment.highlightConfig.goodILevel === false || (equipment.itemLevel ?? 0) >= (equipment.highlightConfig.goodILevelMin ?? 84)"
              [disabled]="!equipment.show || (equipment.itemLevel ?? 0) >= (equipment.highlightConfig.goodILevelMin ?? 84)"
              (click)="toggleGoodILevel()"></button>
          </span>
          <div class="table-checkbox-label">
            <span class="filter-title-text">Good</span>

            @if (equipment.highlightConfig.excellentILevel && !isMobile()) {
              <app-equipment-tier-picker
                [equipmentType]="equipment.highlightConfig.equipmentType === 'jewel' ? EquipmentType.MyJewelsGoodILevel : equipment.highlightConfig.equipmentType === 'jewellery' ? EquipmentType.MyJewelleryGoodILevel : EquipmentType.MyGearGoodILevel"
                [active]="equipment.highlightConfig.goodILevel"
                exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
            }

          </div>
        </div>

        <span class="sep"></span>

        <input type="number" placeholder="min" maxlength="3" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!equipment.show || equipment.highlightConfig.goodILevel === false"
          [(ngModel)]="equipment.highlightConfig.goodILevelMin" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (equipment.highlightConfig.equipmentType !== 'jewel') {
  <div class="filter filter-padded-left" [class.disabled]="!equipment.show">
    <span class="filter-body">
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="toggleAllState === false"
            [disabled]="!equipment.show"
            (click)="toggleAll()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Toggle All</span>
        </div>
      </div>
    </span>
  </div>
}
